let showMessage = () => {};

export const registerShowMessage = (callback) => {
    showMessage = callback;
};

export const notify = (severity, message) => {
    if (showMessage) {
        showMessage({
            severity,
            message
        });
    }
};

export const notifySuccess = (message) =>
    notify("success", message);

export const notifyError = (message) =>
    notify("error", message);

export const notifyWarning = (message) =>
    notify("warning", message);

export const notifyInfo = (message) =>
    notify("info", message);
